export enum EApiTags {
	BRANDS_LIST = 'brands_list',
	NOTIFICATIONS_COUNT = 'NotificationsCount',
	NOTIFICATIONS_LIST = 'NotificationsList',
	OFFERS_LIST = 'offers_list',
	SINGLE_OFFER = 'single_offer',
	POSTBACKS_LIST = 'postbacks_list',
	SINGLE_POSTBACK = 'single_postback',
	SOURCES_LIST = 'sources_list',
	SINGLE_SOURCE = 'single_source',
	TRANSACTIONS_LIST = 'transactions_list',
	SINGLE_TRANSACTION = 'single_transaction',
	PROFILE = 'profile',
	CREDENTIALS = 'credentials',
	DASHBOARD = 'dashboard',
	CONFIG = 'config',
	BANNERS = 'banners',
}
